import _ from 'lodash';

import { INTERNAL_ROLE_NAME_PREFIX } from 'constants/roleNames';
import { checkIsSeededSecurityGroupName, getSecurityGroupDisplayName } from 'utils/securityGroups';

// `startCase` exists to prettify identifier-style role names (`loanOfficer` -> `Loan Officer`). A
// TPO-seeded group's name is a structural key, so it must be resolved to its template label FIRST —
// and then left alone: startCase would turn `TPO-Seed.7f80e2e5….AFR Broker Loan Originator` into
// "TPO Seed 7 F 80 E 2 E 5568… AFR Broker Loan Originator", and even the resolved label would be
// re-cased away from what the lender actually authored.
const getRoleLabel = roleName =>
  checkIsSeededSecurityGroupName(roleName)
    ? getSecurityGroupDisplayName(roleName)
    : _.startCase(roleName);

// `_.filter` rather than a default parameter + Array#filter: master.role is `null` for a guest and is
// reset to `null` on logout while this menu is still mounted (auth master reducer), and a default only
// fires for `undefined` — the code this replaced was null-safe via `master.role?.reduce(...)`.
export const getRoleNamesToDisplay = roleNames =>
  _.filter(roleNames, roleName => !_.toLower(roleName).startsWith(INTERNAL_ROLE_NAME_PREFIX))
    .map(getRoleLabel)
    .join(', ');
